import { enduserApi } from "./client";

/**
 * End the end-user's IdP session and reload. The reload re-runs the `/eu`
 * route guard, which now sees no session and bounces the browser back to the
 * IdP login. The reload happens regardless of the request outcome so the client
 * never gets stuck in a half-logged-out state.
 */
export const logout = async (): Promise<void> => {
  try {
    await enduserApi.post("/logout");
  } catch {
    // Ignore — the reload below drops all client state either way.
  }
  window.location.reload();
};
